// extracted by mini-css-extract-plugin
module.exports = {"load_wrap":"LoadingDots_load_wrap__RnctB","dot":"LoadingDots_dot__y2eBz","scaling":"LoadingDots_scaling__jIunG"};